import { IotsVolumeByTypeListChart } from '@frontend/chart/components';
import { FormattedMessage } from 'react-intl';

import { StatisticsCard } from '../../shared';
import { formatIotTypeLabel } from '../format-iot-type-label';
import { useHardwareIotsVolumeByTypeListChart } from './use-hardware-iots-volume-by-type-list-chart';

export interface HardwareIotsVolumeByTypeListChartProps {
    accountId: string;
}

export const HardwareIotsVolumeByTypeListChart = (props: HardwareIotsVolumeByTypeListChartProps) => {
    const { data, isLoading, navigateToType } = useHardwareIotsVolumeByTypeListChart(props);

    return (
        <StatisticsCard
            chartKey={IotsVolumeByTypeListChart.definition.key}
            title={
                <FormattedMessage
                    id='platform.statistics.hardware.hardware-iots-volume-by-type-list-chart.title'
                    description='Title of the hardware dashboard list showing IoT counts grouped by device type'
                    defaultMessage='Fleet by type'
                />
            }
            isLoading={isLoading}
            hasData={!!data}>
            {data && (
                <div className='min-h-0 flex-1 overflow-y-auto'>
                    <IotsVolumeByTypeListChart
                        data={data}
                        renderItem={(item) => (
                            <button
                                type='button'
                                className='hover:bg-background-surface-hovered flex w-full cursor-pointer items-center justify-between gap-3 rounded-md px-1 py-1 text-left transition-colors'
                                onClick={() => navigateToType(item.key)}>
                                <div className='text-foreground-default min-w-0 text-base font-medium'>{formatIotTypeLabel(item.name)}</div>
                                <span className='text-background-surface bg-brand-muted inline-flex min-w-8 shrink-0 items-center justify-center rounded-full px-2 py-0.5 text-sm font-semibold'>
                                    {item.value}
                                </span>
                            </button>
                        )}
                    />
                </div>
            )}
        </StatisticsCard>
    );
};
